import React, { useState, useEffect } from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPowerOff } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import moment from 'moment'
import { NumericFormat } from 'react-number-format';

const VerCierresdeCaja = ({ baseUrl, Titulo, usuario }) => {

	const [data, setData] = useState([])
	const [funcion, setFuncion] = useState('cargando')

	const peticionTraeDatos = async () => {

		await axios.get(baseUrl)
			.then(response => {
				let respuesta = response.data
				let newArr = []
				respuesta.map(item => {
					let datos = JSON.parse(item.datos)
					newArr.push({
						...item,
						pedidos: datos.pedidos,
						total: parseFloat(datos.total.toFixed(2))
					})
				})
				setData(newArr)
				setFuncion('ver')
				console.log('newArr', newArr)

			}).catch(error => {
				console.log(error)
			})
	}

	const peticionPost = async () => {
		let fechaNueva = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

		//console.log('tipo',tipo)
		let f = new FormData()
		f.append('fecha', fechaNueva)
		f.append('tipo', 'A')
		f.append('usuario', usuario)
		f.append('datos', JSON.stringify({ pedidos: 0, total: 0 }))
		f.append('METHOD', 'POST')
		await axios.post(baseUrl, f)

			.then(response => {
				let respuesta = response.data
				console.log(respuesta)
				//setDataCierres(dataCierres.concat(response.data));
				setData([response.data, ...data])

				//setData(data.concat(response.data));
				console.log('Enviado')
				setFuncion('ver')
				//setFuncion('ver')
			}).catch(error => {
				console.log(error);
			})

	}

	//Trae todas las mediodePagos de la api
	useEffect(() => {
		peticionTraeDatos()
	}, [])


	return (
		<div>
			<div className="row">
				<div className="col-md-6">
					<br />
					<h2>{Titulo}:</h2>
				</div>
				<div className="col-md-6">
					<div className="filtroPedidos">
						<button
							onClick={e => setFuncion('encender')}
							className="btn boton_estandar btn-lg derecha">
							<FontAwesomeIcon icon={faPowerOff} />
						</button>
					</div>
				</div>
			</div>
			{funcion === 'cargando' ?
				<div className="loader">Loading...</div>
				: null}
			{funcion == 'ver' ?
				<div className="row">
					<div className="col-md-12">
						<MDBTable hover>
							<MDBTableHead>
								<tr>
									<th>id</th>
									<th>Tipo</th>
									<th>Fecha y hora</th>
									<th>Realizado por</th>
									<th>No. Pedidos</th>
									<th>Total Bruto</th>
								</tr>
							</MDBTableHead>
							<MDBTableBody>

								{data.map((item, index) => {

									return (
										<tr key={index}>
											<td>{item.id}</td>
											<td>{item.tipo}</td>
											<td>{item.fecha}</td>
											<td>{item.usuario}</td>
											<td>{item.pedidos}</td>
											<td><NumericFormat value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
										</tr>
									)

								})}

							</MDBTableBody>
						</MDBTable>
					</div>
				</div>
				: null}
			{funcion == 'encender' ?
				<div>
					<h4>¿Desea Realmente Activar de nuevo la Caja?</h4>
					<hr />
					<div className="col text-center">

						<button
							onClick={peticionPost}
							className="btn boton_estandar"
						>Activar
						</button>
						<button
							onClick={e => setFuncion('ver')}
							className="btn boton_estandar"
						>Cancelar
						</button>

					</div>
				</div>
				: null}
		</div>
	)
}

export default VerCierresdeCaja